import React from 'react';

import {
  SteeringWalletBasicInfoFragment,
  SteeringWalletFilter,
  SteeringWalletFragment,
  SteeringWalletStatus,
} from '@occc/graphql';
import { useGetBasicInfoWalletsLazy } from '@occc-app/dataAccessLayer/steeringWallet/queries';
import { FormInputProps, LazyAutocompleteFieldNotMultiple } from '@occc-app/design-system';
import { useChainId } from '@occc-app/Chain/hooks';

const inputProps: FormInputProps = { margin: 'none' };
const FIRST = 50;

const mapQueryResponseToRawArray = (
  response: ReturnType<typeof useGetBasicInfoWalletsLazy>['response'],
) => response.data || [];

const mapRawResponseItemToAutocompleteOption = (item: SteeringWalletFragment) => ({
  value: item.uuid,
  label: item.name,
  _raw: item,
});

interface WalletSteeringSelectNotMultipleProps {
  label: string;
  name: string;
}

export const WalletSteeringSelectNotMultiple: React.FC<WalletSteeringSelectNotMultipleProps> = ({
  label,
  name,
}) => {
  const chainId = useChainId();

  const makeQueryFilter: (search: string) => SteeringWalletFilter = React.useCallback(
    (search) => ({
      search,
      chainIdEquals: chainId,
      statusEquals: SteeringWalletStatus.Active,
    }),
    [chainId],
  );

  return (
    <LazyAutocompleteFieldNotMultiple<
      SteeringWalletBasicInfoFragment,
      ReturnType<typeof useGetBasicInfoWalletsLazy>['response']
    >
      name={name}
      label={label}
      useLazyQuery={useGetBasicInfoWalletsLazy}
      makeQueryFilter={makeQueryFilter}
      mapQueryResponseToRawArray={mapQueryResponseToRawArray}
      mapRawResponseItemToAutocompleteOption={mapRawResponseItemToAutocompleteOption}
      inputProps={inputProps}
      first={FIRST}
    />
  );
};
